import React, { Component, Fragment } from "react";
import { withRouteData, Head } from "react-static";

import NewFooter from "../../../blocks/NewFooter/NewFooterV2";
import NewMenu from "../../../blocks/Menu/NewMenu";
import DemoForm from "../../../components/site/Forms/DemoForm";
import CallToActionSection from "../../../blocks/CallToActionSection/CallToActionSection";
import TestimonialsVideoCardsV5 from "../../../blocks/Testimonials/TestimonialsVideoCardsV5";
import Picture from "../../../components/Picture";
import UnifiedFAQ from "../../../components/site/UnifiedFAQ/UnifiedFAQ";
import SimpleAccordionContainer from "../../../components/site/Accordion/SimpleAccordionContainer";
import SimpleAccordionItem from "../../../components/site/Accordion/SimpleAccordionItem";
import TwoColsV2 from "../../../blocks/TwoCols/TwoColsV2";
import SmoothDragScroll from "../../../components/site/DragScroll/SmoothDragScroll";
import FinalCTACard from "../../../blocks/CardFooter/FinalCTACard";

import "./IndustrySystemv2.scss";

class IndustrySystemv2 extends Component {
  constructor(props) {
    super(props);
    this.resourcesSliderRef = React.createRef();
    this.state = {
      canScrollLeft: false,
      canScrollRight: false,
      activeAccordion: 0 // Default to first accordion item
    };
  }

  accordionImages = [
    {
      src: "/images/site/landing-pages/forca-vendas/conectado.png",
      alt: "Imagem trazendo logos de empresas as quais o sistema para indústria Mercos se integra. São elas: Power BI, Tiny, Totvs, Omie, Conta Azul, Sankhya, Bling, RD Station, SAP, Zucchetti e Cigam"
    },
    {
      src: "/images/site/landing-pages/industrias/solucoes.png",
      alt: "Interface de pedidos com inteligência artificial do Mercos para automatizar vendas"
    },
    {
      src: "/images/site/landing-pages/industrias/captacao.png",
      alt: "Dashboard com relatórios de vendas detalhados no sistema Mercos"
    }
  ];

  handleResourcesScroll = (direction) => {
    const scrollAmount = 280;
    const sliderElement = this.resourcesSliderRef.current.slider.current;

    if (direction === 'left') {
      sliderElement.scroll({ left: sliderElement.scrollLeft - scrollAmount, behavior: 'smooth' });
    } else {
      sliderElement.scroll({ left: sliderElement.scrollLeft + scrollAmount, behavior: 'smooth' });
    }
  };

  checkScrollPosition = () => {
    if (this.resourcesSliderRef.current && this.resourcesSliderRef.current.slider.current) {
      const sliderElement = this.resourcesSliderRef.current.slider.current;
      const { scrollLeft, scrollWidth, clientWidth } = sliderElement;
      this.setState({
        canScrollLeft: scrollLeft > 0,
        canScrollRight: scrollLeft < scrollWidth - clientWidth - 1
      });
    }
  };

  componentDidMount() {
    if (this.resourcesSliderRef.current && this.resourcesSliderRef.current.slider.current) {
      const sliderElement = this.resourcesSliderRef.current.slider.current;
      this.checkScrollPosition();
      sliderElement.addEventListener('scroll', this.checkScrollPosition);
    }
  }

  componentWillUnmount() {
    if (this.resourcesSliderRef.current && this.resourcesSliderRef.current.slider.current) {
      const sliderElement = this.resourcesSliderRef.current.slider.current;
      sliderElement.removeEventListener('scroll', this.checkScrollPosition);
    }
  }

  handleAccordionClick = (index) => {
    this.setState({
      activeAccordion: index
    });
  };

  render() {
    return (
      <Fragment>
        {this.props.headData && (
          <Head>
            <title>{this.props.headData.pageTitle}</title>
            <meta property="og:title" content={this.props.headData.pageTitle} />
            <meta name="twitter:title" content={this.props.headData.pageTitle} />
            <meta name="description" content={this.props.headData.pageDescription} />
            <meta property="og:description" content={this.props.headData.pageDescription} />
            <meta name="twitter:description" content={this.props.headData.pageDescription} />
            <meta property="og:image" content={this.props.headData.ogImage} />
            <meta name="twitter:image" content={this.props.headData.ogImage} />
            <meta property="og:url" content={this.props.headData.ogUrl} />
            <link rel="canonical" href={this.props.headData.ogUrl} />
            <script type="application/ld+json">
              {`{
                            "@context": "https://schema.org",
                            "@type": "ImageObject",
                            "contentUrl": "https://mercos.com/images/sistema-de-forca-de-vendas.png",
                            "url": "https://mercos.com/images/sistema-de-forca-de-vendas.png",
                            "name": "Sistema de Força de Vendas",
                            "description": "A imagem mostra alguns dos indicadores do sistema de força de vendas Mercos sendo eles Evolução de Venda, Carteira de Clientes (que contém um gráfico de pizza com Clientes Ativos, Inativos antigos e Recentes e Prospects), E-commerce B2B, valor vendido no mês, situação do cliente nos últimos 6 meses, Pedidos e Atendimentos",
                            "thumbnail": {
                                "@type": "ImageObject",
                                "contentUrl": "https://mercos.com/images/sistema-de-forca-de-vendas.png"
                            },
                            "width": 809,
                            "height": 656,
                            "uploadDate": "2025-08-22",
                            "license": "https://mercos.com/",
                            "author": {
                                "@type": "Organization",
                                "name": "Mercos",
                                "url": "https://www.mercos.com"
                            },
                            "copyrightHolder": {
                                "@type": "Organization",
                                "name": "Mercos"
                            }
                        }`}
            </script>
            <script type="application/ld+json">
              {`{
                            "@context": "https://schema.org",
                            "@type": "FAQPage",
                            "mainEntity": [
                                {
                                    "@type": "Question",
                                    "name": "O que é o sistema para indústria Mercos?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "O Mercos é um sistema para indústria que elimina retrabalhos e erros na gestão de pedidos, automatizando o processo comercial, integrando-se a ERPs e a outros sistemas das indústrias.\\n\\nCom e-commerce B2B, inteligência artificial e aplicativo mobile (que funciona inclusive offline), permite que representantes e equipes internas emitam pedidos de qualquer lugar, garantindo mais controle, visibilidade e dados confiáveis para decisões estratégicas."
                                    }
                                },
                                {
                                    "@type": "Question",
                                    "name": "Quais setores podem usar um sistema para indústria como o Mercos?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "O Mercos atende diferentes setores que trabalham no modelo B2B no segmento de bens de consumo, como indústrias de alimentos e bebidas, higiene e limpeza, cosméticos, materiais de construção, moda e confecção, autopeças e muitas outras.\\n\\nQualquer empresa industrial que venda para outras empresas e tenha equipes de vendas pode se beneficiar de um sistema para indústria como o Mercos, ganhando agilidade nos pedidos e integração total com o restante da operação."
                                    }
                                },
                                {
                                    "@type": "Question",
                                    "name": "O Mercos é indicado para minha indústria?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "Sim, o Mercos é um sistema para indústria indicado para gestores que desejam otimizar a gestão comercial e o processo de pedidos B2B. Ele potencializa as vendas ao disponibilizar uma ferramenta prática para representantes e vendedores internos, facilita o acompanhamento de resultados e garante uma visão completa da operação.\\n\\nAlém disso, com inteligência artificial, economiza até 90% do tempo perdido em pedidos recebidos pelo WhatsApp, reduz erros com a automatização, integra-se a outros sistemas e oferece um e-commerce B2B para os clientes comprarem online, 24 horas por dia."
                                    }
                                },
                                {
                                    "@type": "Question",
                                    "name": "Como o Mercos integra vendas e produção?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "O Mercos conecta a área comercial ao chão de fábrica registrando pedidos em tempo real, atualizando automaticamente o estoque e enviando essas informações para o ERP. Assim, a produção consegue se planejar conforme a demanda real, evitando atrasos, gargalos e rupturas de materiais.\\n\\nEssa integração faz com que o sistema para indústria alinhe vendas e produção, aumentando a eficiência da operação."
                                    }
                                },
                                {
                                    "@type": "Question",
                                    "name": "Qual a diferença entre o sistema para indústria Mercos e um sistema ERP?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "Um ERP é voltado para a gestão administrativa, contábil e produtiva da empresa, enquanto o Mercos é um sistema para indústria especializado em vendas. Ele atua como uma extensão comercial do ERP: organiza pedidos, facilita o relacionamento com clientes, dá mobilidade aos representantes e permite a venda online via e-commerce B2B.\\n\\nEm resumo, o ERP cuida da retaguarda e o Mercos garante que as vendas da indústria fluam com agilidade e precisão. O Mercos se integra a qualquer ERP do mercado."
                                    }
                                },
                                {
                                    "@type": "Question",
                                    "name": "Qual a diferença entre o Mercos e um CRM?",
                                    "acceptedAnswer": {
                                        "@type": "Answer",
                                        "text": "O Mercos também é um CRM, mas vai além do tradicional. Enquanto o CRM tradicional se concentra somente no relacionamento com o cliente, o Mercos combina essa gestão com recursos de sistema para indústria com foco em vendas, como automação de pedidos, controle de estoque, relatórios estratégicos e integração com ERPs e BIs.\\n\\nAssim, ele une a visão estratégica de um CRM à eficiência operacional que a indústria precisa para vender com controle e organização. Porém, caso a indústria já conte com um CRM na operação, o Mercos pode ser integrado a ele ou a qualquer CRM do mercado."
                                    }
                                }
                            ]
                        }`}
            </script>
          </Head>
        )}

        <div className="new-industry-system-v2">
          <NewMenu transparentOnTop pixelsToShowMenuWhite={50} mutableMenu hideOnScroll />

          <section className="new-industry-hero hero">
            <div className="container">
              <div className="column">
                <h1>
                  <span className="overtitle">Sistema para indústria n°1 do mercado</span>
                  <br />
                  <span className="title">Emissão de pedidos com IA, automação da força de vendas e controle operacional</span>
                </h1>
                <h2 className="description">
                  O Mercos é o software para indústria mais prático e completo do mercado, entregando <b>gestão e controle total de vendas, estoque e equipe, CRM e integração com qualquer ERP</b> em um só lugar
                </h2>
                <DemoForm textAlign="left" buttonVariant="inverted" />
              </div>
              <div className="column form-col">
                <Picture src="/images/site/landing-pages/industrias/hero-img.png" alt="Imagem de um homem sorridente com seu celular na mão, usando o Mercos, o sistema para indústria que é líder de mercado. É possível ver gráficos, como Curva ABC de Clientes, Análise de Clientes por região do Brasil. Há também lembretes da opção de criar pedidos com IA e de acompanhar um vendedor em uma visita que ele fará a um atacadão, demonstrando que o Mercos oferece eficiência e inovação industrial" />
              </div>
            </div>
          </section>

          <TestimonialsVideoCardsV5 industryVersion={true} />
          <section className="benefits-accordion-section">
            <div className="container">
              <div className="content-wrapper">
                <div className="features-list">
                  <div className="section-header">
                    <h3>
                      <span className="overtitle">Fim dos erros e retrabalhos</span>
                      <span className="title">
                        Visão completa
                        <br /> da sua operação
                      </span>
                    </h3>
                    <p className="description">Centralize as informações da sua indústria, ganhe tempo para tarefas estratégicas e deixe que a tecnologia do Mercos ajude você a vender mais</p>
                  </div>
                  <SimpleAccordionContainer expand="arrow" collapsable>
                    <SimpleAccordionItem title="Múltiplas integrações" headerTag="h4" onClick={() => this.handleAccordionClick(0)}>
                      <p>Integre o sistema para indústria Mercos com ERPs, BIs, CRMs ou os softwares que desejar, de forma simples e segura</p>
                      <Picture className="mobile-only" src="/images/site/landing-pages/forca-vendas/conectado.png" alt="Imagem trazendo logos de empresas as quais o sistema para indústria Mercos se integra" />
                    </SimpleAccordionItem>
                    <SimpleAccordionItem title="Soluções com Inteligência Artificial" headerTag="h4" onClick={() => this.handleAccordionClick(1)}>
                      <p>Nossa IA transforma mensagens de WhatsApp em pedidos em segundos e sugere produtos com base no histórico do cliente</p>
                      <Picture className="mobile-only" src="/images/site/landing-pages/industrias/solucoes.png" alt="Interface de pedidos com inteligência artificial do Mercos para automatizar vendas" />
                    </SimpleAccordionItem>
                    <SimpleAccordionItem title="Captação e processamento ágil de pedidos" headerTag="h4" onClick={() => this.handleAccordionClick(2)}>
                      <p>Acompanhe os passos das equipes externas e internas enquanto eles tiram pedidos com agilidade e focam em atender com excelência</p>
                      <Picture className="mobile-only" src="/images/site/landing-pages/industrias/captacao.png" alt="Dashboard com relatórios de vendas detalhados no sistema Mercos" />
                    </SimpleAccordionItem>
                  </SimpleAccordionContainer>
                </div>
                <div className="main-image desktop-only">
                  <Picture src={this.accordionImages[this.state.activeAccordion].src} alt={this.accordionImages[this.state.activeAccordion].alt} />
                </div>
              </div>
            </div>
          </section>

          <section className="icon-features-section">
            <div className="container">
              <div className="icon-features">
                <div className="icon-feature-item">
                  <div className="icon-wrapper">
                    <Picture src="/images/site/icons/dolar.svg" alt="Previsibilidade nas vendas" />
                  </div>
                  <div className="icon-feature-content">
                    <p className="icon-feature-title">Venda de qualquer lugar, até sem internet</p>
                    <p className="icon-feature-description">Sua equipe vende presencialmente, com um aplicativo mobile que funciona mesmo offline, ou vende online com o e-commerce B2B</p>
                  </div>
                </div>
                <div className="icon-feature-item">
                  <div className="icon-wrapper">
                    <Picture src="/images/site/icons/graph-arrow-up.png" alt="Venda de qualquer lugar" />
                  </div>
                  <div className="icon-feature-content">
                    <p className="icon-feature-title">Tenha previsibilidade na rotina de vendas</p>
                    <p className="icon-feature-description">Acesse indicadores e relatórios que garantem uma operação analítica, eficiente, preditiva e pautada em dados confiáveis</p>
                  </div>
                </div>
                <div className="icon-feature-item">
                  <div className="icon-wrapper">
                    <Picture src="/images/site/icons/flag-white.png" alt="Políticas em tempo real" />
                  </div>
                  <div className="icon-feature-content">
                    <p className="icon-feature-title">Políticas atualizadas em tempo real</p>
                    <p className="icon-feature-description">Compartilhe políticas comerciais em tempo real e garanta preços, descontos e pagamentos aplicados sem erro</p>
                  </div>
                </div>
                <div className="icon-feature-item">
                  <div className="icon-wrapper">
                    <Picture src="/images/site/icons/person-frame.png" alt="Autonomia para compradores" />
                  </div>
                  <div className="icon-feature-content">
                    <p className="icon-feature-title">Dê autonomia para seus compradores</p>
                    <p className="icon-feature-description">Com o Portal do Cliente, um canal digital gratuito e integrado ao Mercos, os compradores acessam históricos e NFs com autonomia</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <TwoColsV2
            overTitle="Venda online descomplicada"
            title="E-commerce B2B para vender a qualquer hora"
            description={(<h4>Venda por uma <b>loja online personalizada para sua indústria</b>, permitindo que seu vendedor finalize o pedido ou que seu cliente pague por cartão, boleto ou pix, usando o Mercos Pay</h4>)}
            imageSrc="/images/site/landing-pages/industrias/e-commerce-b2b.png"
            imageAlt="Tela do e-commerce B2B para indústria Mercos, exibindo produtos como caneca de café e cesta graffiti, com a loja virtual podendo ser personalizada conforme o segmento e setor da indústria"
            isReverse={true}
            testimonial={{
              text: "Além de vender online com o e-commerce B2B da Mercos, passamos a transacionar 95% do faturamento diretamente pelo sistema com o Mercos Pay, economizando 2 dias de trabalho por mês. Também reduzimos em 10x o tempo de emissão de notas e cobranças com a integração com nosso ERP.",
              personName: "Allan Gomes",
              companyName: "La Ganexa",
              personImage: "/images/site/depoimentos/allan-gomes.png",
            }}
            radialBg="purple"
            testimonialElementType="p"
          />

          <section className="resources-section">
            <div className="container">
              <div className="resources-header">
                <h3>
                  <span className="overtitle">Recursos para a gestão e suas equipes</span>

                  <span className="title">Confira os diferenciais do Mercos</span>
                </h3>
                <p>Confira como o sistema para indústria Mercos otimiza<br/> sua operação comercial de ponta a ponta, na prática</p>
                <div className="mobile-scroll-indicators">
                  <div className={`scroll-arrow left ${this.state.canScrollLeft ? 'active' : ''}`} onClick={() => this.handleResourcesScroll('left')}>
                    <Picture src="/images/site/arrow.svg" alt="Scroll left" />
                  </div>
                  <div className={`scroll-arrow right ${this.state.canScrollRight ? 'active' : ''}`} onClick={() => this.handleResourcesScroll('right')}>
                    <Picture src="/images/site/arrow.svg" alt="Scroll right" />
                  </div>
                </div>
              </div>
            </div>
            <div className="resources-cards-wrapper">
              <SmoothDragScroll ref={this.resourcesSliderRef} className="resources-cards">
                <div className="card-spacer"></div>
                <div className="resource-card" title="Acompanhe quanto já foi vendido e veja a projeção do resultado ao final do mês, ajustando sua estratégia para sempre bater as metas">
                  <Picture src="/images/site/landing-pages/industrias/1-evolucao-vendas.png" alt="Imagem do indicador Evolução de Venda do Mercos, que mostra quanto a indústria faturou no mês e qual seu objetivo por meio de um gráfico" />
                  <Picture src="/images/site/icons/tooltip.svg" alt="Info" className="tooltip-icon" />
                </div>
                <div className="resource-card" title="Centralize todos os pedidos concluídos, orçamentos e cancelamentos em um só lugar, com filtros para acompanhar as vendas da indústria em detalhes">
                  <Picture src="/images/site/landing-pages/industrias/2-relatorio-vendas.png" alt="Imagem do relatório de vendas do Mercos, mostrando um gráfico de pizza que traz as vendas e orçamentos concluídos no período definido pela indústria" />
                  <Picture src="/images/site/icons/tooltip.svg" alt="Info" className="tooltip-icon" />
                </div>
                <div className="resource-card" title="Respondemos a toda sua equipe em até 20 segundos no chat ou WhatsApp em horário comercial">
                  <Picture src="/images/site/landing-pages/industrias/3-suporte-tempo-real.png" alt="Homem sorridente usando o celular para acionar o chat em tempo real da Mercos. Na conversa é possível conferir a seguinte troca de mensagem: 'Olá, estou com uma dúvida, pode me ajudar?', 'Claro, como posso lhe ajudar'?" />
                  <Picture src="/images/site/icons/tooltip.svg" alt="Info" className="tooltip-icon" />
                </div>
                <div className="resource-card" title="Analise sua carteira por região, classificando clientes entre prospects, ativos e inativos, priorize atendimentos, evite inativações e gere mais vendas">
                  <Picture src="/images/site/landing-pages/industrias/4-acompanhamento-ativo.png" alt="Imagem mostrando o indicador 'Situação de Carteira de Cliente' do Mercos. É possível ver o mapa do Brasil divido em cores para o gestor de indústria analisar clientes ativos e inativos e formular estratégias a partir disso. Verde escuro e claro mostram quais estados a indústria tem clientes ativos, amarelo mostra locais com inativos recentes e vermelho mostra locais com inativos antigos" />
                  <Picture src="/images/site/icons/tooltip.svg" alt="Info" className="tooltip-icon" />
                </div>
                <div className="resource-card" title="Compare, por vendedor, o número de clientes ativos que fizeram pedidos no mês, identificando quem movimenta mais as carteiras">
                  <Picture src="/images/site/landing-pages/industrias/5-ranking-metas.png" alt="Imagem mostrando o relatório 'Positivação por vendedor' do Mercos, permitindo que a gestão da indústria acompanhe quanto cada vendedor positivou em um período, bem como quantos porcento da meta ele atingiu e sua posição no ranking da equipe" />
                  <Picture src="/images/site/icons/tooltip.svg" alt="Info" className="tooltip-icon" />
                </div>
                <div className="resource-card" title="Planeje visitas e organize o tempo de trabalho, otimizando deslocamento e produtividade">
                  <Picture src="/images/site/landing-pages/industrias/6-agenda-roterizacao.png" alt="Imagem mostrando o relatório de Pedidos e atendimentos do Mercos, trazendo o 'Orçamento #165', com data, horário e nome do vendedor ao qual o orçamento foi solicitado, bem como o nome do cliente, o valor e a condição de pagamento. Também é possível acompanhar ligações que os vendedores fizeram e demais contatos com clientes" />
                  <Picture src="/images/site/icons/tooltip.svg" alt="Info" className="tooltip-icon" />
                </div>
                <div className="resource-card" title="A Inteligência Artificial entende os pedidos que você recebe por mensagem, gera uma lista de produtos e lança no sistema em segundos">
                  <Picture src="/images/site/landing-pages/industrias/7-pedidos-ia.png" alt="Imagem mostrando o recurso Pedidos com IA do sistema para indústria Mercos. É possível ler uma troca de conversa pelo WhatsApp entre vendedor e cliente, com o vendedor podendo pegar o print da conversa, por exemplo, e lançar no Pedidos com IA Mercos, que criará o pedido diretamente dentro do sistema usando inteligência artificial e ajudando-o a economizar até 90% do tempo gasto em pedidos e orçamentos" />
                  <Picture src="/images/site/icons/tooltip.svg" alt="Info" className="tooltip-icon" />
                </div>
                <div className="resource-card" title="A solução de pagamentos da Mercos permite recebimentos por cartão, boleto, link de pagamento ou Pix, direto do sistema">
                  <Picture src="/images/site/landing-pages/industrias/8-mercos-pay.png" alt="Tela do Mercos Pay mostrando opções de pagamento integradas ao sistema" />
                  <Picture src="/images/site/icons/tooltip.svg" alt="Info" className="tooltip-icon" />
                </div>
                <div className="resource-card" title="Analise o relatório de comissões por vendedor e por período, identifique oportunidades de incentivo e ajuste estratégias para aumentar os resultados">
                  <Picture src="/images/site/landing-pages/industrias/9-comissionamento.png" alt="Imagem mostrando o relatório de 'Comissão por Vendedor' do Mercos, que permite que a gestão da indústria acompanhe de perto o comissionamento da equipe" />
                  <Picture src="/images/site/icons/tooltip.svg" alt="Info" className="tooltip-icon" />
                </div>
              </SmoothDragScroll>
            </div>
          </section>

          <UnifiedFAQ
              subtitle={(<p>Não conhece o sistema para indústria da Mercos?<br /> Confira as principais dúvidas que podem surgir.</p>)}
              titleId="industry-system-faq-title"
              faqItems={[
                {
                  question: 'O que é o sistema para indústria Mercos?',
                  answer: (
                    <Fragment>
                      <p>O Mercos é um sistema para indústria que elimina retrabalhos e erros na gestão de pedidos, automatizando o processo comercial, integrando-se a ERPs e a outros sistemas das indústrias.</p>
                                        <p>Com e-commerce B2B, inteligência artificial e aplicativo mobile (que funciona inclusive offline), permite que representantes e equipes internas emitam pedidos de qualquer lugar, garantindo mais controle, visibilidade e dados confiáveis para decisões estratégicas.</p>
                    </Fragment>
                  )
                },
                {
                  question: 'Quais setores podem usar um sistema para indústria como o Mercos?',
                  answer: (
                    <Fragment>
                      <p>O Mercos atende diferentes setores que trabalham no modelo B2B no segmento de bens de consumo, como indústrias de alimentos e bebidas, higiene e limpeza, cosméticos, materiais de construção, moda e confecção, autopeças e muitas outras.</p>
                                        <p>Qualquer empresa industrial que venda para outras empresas e tenha equipes de vendas pode se beneficiar de um sistema para indústria como o Mercos, ganhando agilidade nos pedidos e integração total com o restante da operação.</p>
                    </Fragment>
                  )
                },
                {
                  question: 'O Mercos é indicado para minha indústria?',
                  answer: (
                    <Fragment>
                      <p>Sim, o Mercos é um sistema para indústria indicado para gestores que desejam otimizar a gestão comercial e o processo de pedidos B2B. Ele potencializa as vendas ao disponibilizar uma ferramenta prática para representantes e vendedores internos, facilita o acompanhamento de resultados e garante uma visão completa da operação.</p>
                                        <p>Além disso, com inteligência artificial, economiza até 90% do tempo perdido em pedidos recebidos pelo WhatsApp, reduz erros com a automatização, integra-se a outros sistemas e oferece um e-commerce B2B para os clientes comprarem online, 24 horas por dia.</p>
                    </Fragment>
                  )
                },
                {
                  question: 'Como o Mercos integra vendas e produção?',
                  answer: (
                    <Fragment>
                      <p>O Mercos conecta a área comercial ao chão de fábrica registrando pedidos em tempo real, atualizando automaticamente o estoque e enviando essas informações para o ERP. Assim, a produção consegue se planejar conforme a demanda real, evitando atrasos, gargalos e rupturas de materiais.</p>
                                        <p>Essa integração faz com que o sistema para indústria alinhe vendas e produção, aumentando a eficiência da operação.</p>
                    </Fragment>
                  )
                },
                {
                  question: 'Qual a diferença entre o sistema para indústria Mercos e um sistema ERP?',
                  answer: (
                    <Fragment>
                      <p>Um ERP é voltado para a gestão administrativa, contábil e produtiva da empresa, enquanto o Mercos é um sistema para indústria especializado em vendas. Ele atua como uma extensão comercial do ERP: organiza pedidos, facilita o relacionamento com clientes, dá mobilidade aos representantes e permite a venda online via e-commerce B2B.</p>
                                        <p>Em resumo, o ERP cuida da retaguarda e o Mercos garante que as vendas da indústria fluam com agilidade e precisão. O Mercos se integra a qualquer ERP do mercado.</p>
                    </Fragment>
                  )
                },
                {
                  question: 'Qual a diferença entre o Mercos e um CRM?',
                  answer: (
                    <Fragment>
                      <p>O Mercos também é um CRM, mas vai além do tradicional. Enquanto o CRM tradicional se concentra somente no relacionamento com o cliente, o Mercos combina essa gestão com recursos de sistema para indústria com foco em vendas, como automação de pedidos, controle de estoque, relatórios estratégicos e integração com ERPs e BIs.</p>
                                        <p>Assim, ele une a visão estratégica de um CRM à eficiência operacional que a indústria precisa para vender com controle e organização. Porém, caso a indústria já conte com um CRM na operação, o Mercos pode ser integrado a ele ou a qualquer CRM do mercado.</p>
                    </Fragment>
                  )
                },
              ]}
            />
    
          <section className="final-cta-section-v5">
            <FinalCTACard />
          </section>

        </div>
        <NewFooter />
      </Fragment>
    );
  }
}

export default withRouteData((props) => <IndustrySystemv2 {...props} />);



// WEBPACK FOOTER //
// /usr/src/site-blog/src/containers/site/landing-pages/IndustrySystemv2.jsx